import { Music, Loader2 } from "lucide-react"

import { SongCard } from "./SongCard"

interface Song {
  id: string
  title: string
  artist: string | null
  genre: string
  status: "uploading" | "uploaded" | "separating" | "analyzing" | "ready" | "error"
  bpm: number | null
  camelotKey: string | null
  duration: number | null
  originalFileUrl: string | null
  vocalsFileUrl: string | null
  instrumentalFileUrl: string | null
  errorMessage: string | null
  createdAt: Date
}

interface SongLibraryProps {
  songs: Song[]
  isLoading: boolean
  onRefresh: () => void
}

export function SongLibrary({ songs, isLoading, onRefresh }: SongLibraryProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (songs.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="p-4 bg-muted rounded-full mb-4">
          <Music className="h-12 w-12 text-muted-foreground" />
        </div>
        <h3 className="text-lg font-medium mb-2">No songs yet</h3>
        <p className="text-sm text-muted-foreground max-w-md">
          Upload your first song to get started. We&apos;ll automatically separate the stems (vocals, drums, bass) and
          analyze the BPM for mashup creation.
        </p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {songs.map((song) => (
        <SongCard key={song.id} song={song} onRefresh={onRefresh} />
      ))}
    </div>
  )
}
